import { showDialogError, showDialogSuccess, showDeleteConfirmation } from '../sweealert2';
import { Modal, Tooltip } from 'bootstrap';

$(document).ready(function () {
  function clientCompanyTabElements() {
    return Array.from(document.querySelectorAll('#tab-pane-company[data-persist-active-tab="query"] > .nav-item > .nav-link'));
  }

  function clientCompanyTabFromUrl() {
    const url = new URL(window.location.href);
    const currentTab = url.searchParams.get('current_tab');

    return clientCompanyTabElements().find((tabElement) => {
      return tabElement.id === currentTab || tabElement.getAttribute('href') === `#${currentTab}`;
    });
  }

  function clientCompanyTabFromHash() {
    if (!window.location.hash) return null;

    return clientCompanyTabElements()
      .find((tabElement) => tabElement.getAttribute('href') === window.location.hash);
  }

  function activateClientCompanyTab(tabElement) {
    const tabList = tabElement.closest('#tab-pane-company[data-persist-active-tab="query"]');
    const tabContent = tabList && document.getElementById(tabList.dataset.tabContent);
    const pane = document.getElementById(tabElement.getAttribute('href').slice(1));

    if (!tabList || !tabContent || !pane) return;

    tabList.querySelectorAll(':scope > .nav-item > .nav-link').forEach((navLink) => {
      navLink.classList.remove('active');
      navLink.setAttribute('aria-selected', 'false');
    });

    Array.from(tabContent.children).forEach((tabPane) => {
      if (tabPane.classList.contains('tab-pane')) {
        tabPane.classList.remove('show', 'active');
      }
    });

    tabElement.classList.add('active');
    tabElement.setAttribute('aria-selected', 'true');
    pane.classList.add('show', 'active');
  }

  function persistClientCompanyTab(tabElement) {
    if (!tabElement.id) return;

    const url = new URL(window.location.href);
    url.searchParams.set('current_tab', tabElement.id);
    url.hash = '';
    window.history.replaceState(null, '', url.toString());
  }

  const hashTabElement = clientCompanyTabFromHash();
  if (!clientCompanyTabFromUrl() && hashTabElement) {
    activateClientCompanyTab(hashTabElement);
    persistClientCompanyTab(hashTabElement);
  }

  $(document).on('shown.bs.tab', '#tab-pane-company[data-persist-active-tab="query"] > .nav-item > .nav-link', function () {
    persistClientCompanyTab(this);
  });

  window.initClientCompanyTooltips = function (containerSelector = document) {
    $(containerSelector).find('[data-bs-toggle="tooltip"]').each(function () {
      Tooltip.getInstance(this) || new Tooltip(this, { container: 'body' });
    });
  };

  window.initClientCompanyTooltips('#client-ordered-item-table');

  function initImportedPropertySelect2(containerSelector = document) {
    $(containerSelector)
      .find('#project-client-company select.object_lease_type, #project-client-company select.product-id, #project-client-company select.leasing_company')
      .each(function () {
        const $select = $(this);
        const $importOption = $select.find('option[data-import-option="true"]');
        if ($importOption.length === 0) return;

        if ($select.hasClass('select2-hidden-accessible')) {
          $select.select2('destroy');
        }

        $select.select2({
          width: '100%',
          theme: 'bootstrap',
          language: {
            noResults: function () {
              return '見つかりません。';
            },
          },
        });
      });
  }

  initImportedPropertySelect2();

  $(document).on('cocoon:after-insert', '#project-client-company, #wrap-problem-company, #sale_business', function (e, insertedItem) {
    let $select2Elm = $(insertedItem).find(".form-select.select2");
    _.forEach($select2Elm, function ($elm) {
      $($elm).select2({
        theme: 'bootstrap',
        placeholder: '選択してください',
        allowClear: true,
        language: {
          noResults: function () {
            return '見つかりません。';
          },
        },
      });
    });
  });

  $(document).on('cocoon:after-insert', '#wrap-problem-company, #sale-info-table, #project-client-company', function (e, insertedItem) {
    initDateRangePicker();
  });


  function initDateRangePicker() {
    $('input.singledate').daterangepicker({
      locale: ja_date_locale,
      singleDatePicker: true,
      autoUpdateInput: false,
      autoApply: true,
    });

    $('input.singledate').on('apply.daterangepicker', function (ev, picker) {
      $(this).val(picker.startDate.format('YYYY/MM/DD'));
      if (window.validateRepresentativeBirthday && $(this).hasClass('js-representative-birthday')) {
        window.validateRepresentativeBirthday($(this), picker.startDate.format('YYYY/MM/DD'));
      }
    });

    $('input.singledate').on('cancel.daterangepicker', function (ev, picker) {
      $(this).val('');
      if (window.validateRepresentativeBirthday && $(this).hasClass('js-representative-birthday')) {
        window.validateRepresentativeBirthday($(this), '');
      }
    });
  }

  function saleInfoModal() {
    const modalElement = document.getElementById('sale-info-modal');
    return Modal.getInstance(modalElement) || new Modal(modalElement);
  }

  function resetSaleInfoErrors() {
    $('#sale-info-modal-form .help-block').addClass('d-none').text('');
    $('#sale-info-modal-form .has-error').removeClass('has-error');
  }

  function setSaleInfoError(field, message) {
    const $message = $(`#sale-info-modal-form [data-error-for='${field}']`);
    $message.removeClass('d-none').text(message);
    $message.closest('.form-group').addClass('has-error');
  }

  function saleInfoContentLength() {
    return $('#sale-info-content').val().length;
  }

  function updateSaleInfoContentCount() {
    $('#sale-info-content-count').text(saleInfoContentLength());
  }

  function validSaleInfoForm() {
    resetSaleInfoErrors();

    const dateValue = $('#sale-info-effect-date').val();
    const contentLength = saleInfoContentLength();
    const dateRegex = /^[0-9]{4}\/(0[1-9]|1[012])\/(0[1-9]|1[0-9]|2[0-9]|3[01])$/;
    let isValid = true;

    if (!dateValue) {
      setSaleInfoError('effect_date', '日付を入力してください。');
      isValid = false;
    } else if (!dateRegex.test(dateValue)) {
      setSaleInfoError('effect_date', 'YYYY/MM/DD形式で入力してください。');
      isValid = false;
    }

    if (contentLength > 1000) {
      setSaleInfoError('content', '1000字以内で入力してください。');
      isValid = false;
    }

    return isValid;
  }

  function refreshSaleInfoTable(html) {
    $('#sale-info-table-body').replaceWith(html);
    window.initClientCompanyTooltips('#sale-info-table');
  }

  function openSaleInfoModal(options) {
    resetSaleInfoErrors();
    $('#sale-info-modal-title').text(options.title);
    $('#sale-info-method').val(options.method);
    $('#sale-info-url').val(options.url);
    $('#sale-info-effect-date').val(options.effectDate);
    $('#sale-info-worker-name').val(options.workerName);
    $('#sale-info-content').val(options.content || '');
    updateSaleInfoContentCount();
    initDateRangePicker();
    saleInfoModal().show();
  }

  $('#sale-info-content').on('input', function () {
    updateSaleInfoContentCount();
  });

  $('#js-open-sale-info-modal').on('click', function () {
    const $button = $(this);
    openSaleInfoModal({
      title: '営業情報登録',
      method: 'POST',
      url: $button.data('url'),
      effectDate: $button.data('current-date'),
      workerName: $button.data('worker-name'),
      content: ''
    });
  });

  $(document).on('click', '.js-edit-sale-info', function () {
    const $button = $(this);
    openSaleInfoModal({
      title: '営業情報編集',
      method: 'PATCH',
      url: $button.data('url'),
      effectDate: $button.data('effect-date'),
      workerName: $button.data('worker-name'),
      content: $button.data('content') || ''
    });
  });

  $('#sale-info-submit').on('click', function () {
    if (!validSaleInfoForm()) return;

    $.ajax({
      url: $('#sale-info-url').val(),
      method: $('#sale-info-method').val(),
      dataType: 'json',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      data: {
        sale_client_company: {
          effect_date: $('#sale-info-effect-date').val(),
          content: $('#sale-info-content').val()
        }
      },
      success: function (response) {
        refreshSaleInfoTable(response.html);
        saleInfoModal().hide();
        showDialogSuccess('保存に成功しました。');
      },
      error: function (xhr) {
        resetSaleInfoErrors();
        const errors = xhr.responseJSON && xhr.responseJSON.errors;
        if (errors) {
          _.forEach(errors, function (messages, field) {
            setSaleInfoError(field, messages[0]);
          });
        } else {
          showDialogError('保存に失敗しました。');
        }
      }
    });
  });

  $(document).on('click', '.js-delete-sale-info', function () {
    const url = $(this).data('url');
    showDeleteConfirmation({ text: '営業情報を削除しますか' }, function () {
      $.ajax({
        url: url,
        method: 'DELETE',
        dataType: 'json',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        success: function (response) {
          refreshSaleInfoTable(response.html);
          showDialogSuccess('削除しました。');
        },
        error: function () {
          showDialogError('削除に失敗しました。');
        }
      });
    });
  });

  $('.form-client-company #client_company_company_id').on('change', function () {
    let companyId = $(this).val();

    const listId = [
      'client_company_note',
      'assigned_industry_ids',
      'name_kana',
      'kintone_code',
      'rakuraku_code',
      'name',
      'representative_name',
      'zipcode',
      'capical',
      'client_company_pc_num',
      'client_company_company_attributes_established_at',
      'address1',
      'address2',
      'company_code',
      'company_office_name',
      'tel',
      'client_company_company_attributes_rank_status_id',
      'company_type_id',
      'juridical_personality_position',
      'bill_code',
      'apl',
      'pca',
      'fax',
      'email',
      'representative_role',
      'closing_day',
      'payment_type',
      'payment_month_type',
      'payment_day',
      'client_company_company_attributes_parent_company_id',
      'client_company_company_attributes_group_company_id'
    ];

    _.forEach(listId, function (value) {
      $(`#${value}`).val('').change();
    });

    $('input[name="client_company[pay_status]"]').prop('checked', false);
    $('input[name="client_company[company_attributes][id]"]').val('');
    if (companyId) {
      $.ajax({
        url: `/companies/${companyId}/load_company`,
        method: 'GET',
        success: function (res) {
          const company = res.company;

          $('input[name="client_company[company_attributes][id]"]').val(company.id);
          $('#client_company_note').val(company.note);
          $('#assigned_industry_ids').val(company.assigned_industry_ids).change();
          $('#name_kana').val(company.name_kana);
          $('#kintone_code').val(company.kintone_code);
          // $('#name').val(company.name);
          $('#representative_name').val(company.representative_name);
          $('#zipcode').val(company.zipcode);
          $('#capical').val(company.capical);
          $('#client_company_pc_num').val(company.pc_num);
          $('#client_company_company_attributes_established_at').val(res.established_at);
          $('#address1').val(company.address1);
          $('#address2').val(company.address2);
          $('#company_code').val(company.padded_company_code);
          // Fill office name if present on the Company record
          $('#company_office_name').val(company.office_name);
          $('#tel').val(company.tel);
          $('input[name="client_company[pay_status]"]').prop('checked', false);
          if (company.status) {
            $('#client_company_pay_status_' + company.status).prop('checked', true);
          }
          $('#client_company_company_attributes_rank_status_id_' + company.rank_status_id).prop('checked', true);
          $('#company_type_id').val(company.company_type_id).change();
          $('#juridical_personality_position').val(company.juridical_personality_position).change();
          $('#bill_code').val(company.bill_code);
          $('#apl').val(company.apl).change();
          $('#pca').val(company.pca).change();
          $('#fax').val(company.fax);
          $('#email').val(company.email);
          $('#representative_role').val(company.representative_role);
          $('#closing_day').val(company.closing_day).change();
          $('#payment_type').val(company.client_payment_type).change();
          $('#payment_month_type').val(company.payment_month_type).change();
          $('#payment_day').val(company.payment_day).change();
          $('#client_company_company_attributes_parent_company_id').val(company.parent_company_id).change();
          $('#client_company_company_attributes_group_company_id').val(company.group_company_id).change();
        },
      });
    }
  });

  $('#capical').on('keyup', function () {
    let valString = $(this).val();

    valString = valString.replace(/\,/g, '');
    x = valString.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';

    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }

    $(this).val(x1 + x2);
  });

  $('#capical').on('keypress paste', function (event) {
    const theEvent = event || window.event;
    if (theEvent.type === 'paste') {
      key = [];
    } else {
      key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }

    const regex = /[0-9０-９]|\./;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  });

  $(document).on("click", ".js-submit-update-client", function () {
    var $form = $("#client-company-edit-form");
    $form.find(".help-block").not(".js-representative-birthday-error").remove();
    $form.find(".has-error").not(".js-representative-birthday-wrap").removeClass("has-error");
    var $birthday = $form.find('.js-representative-birthday');
    if ($birthday.length && window.validateRepresentativeBirthday && !window.validateRepresentativeBirthday($birthday)) {
      $('#basic-tab').trigger('click');
      $birthday[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var id = $form.data("company-id");
    var actionURL = $form.attr("action");

    function fieldSelector(name) {
      return `input[name='${name}'], select[name='${name}'], textarea[name='${name}']`;
    }

    function addFieldError($inputElm, message) {
      if (!$inputElm.length) return false;

      var $formGroup = $inputElm.closest(".form-group, .input, .select, .string, .integer, .boolean, .text");
      if (!$formGroup.length) {
        $formGroup = $inputElm.parent();
      }

      $formGroup.addClass("has-error");
      $formGroup.find(".help-block").remove();

      var $message = $("<span class='help-block text-danger'></span>").text(message);
      var $select2Container = $inputElm.next(".select2-container");
      if ($select2Container.length) {
        $select2Container.after($message);
      } else {
        $inputElm.after($message);
      }
      addErrorTab($inputElm);

      return true;
    }

    function showClientCompanyErrors(response) {
      var hasRenderedInlineError = false;
      var dialogMessages = [];

      _.forEach(response.errors, function (errors, key) {
        if (errors && errors[0]) {
          dialogMessages.push(errors[0]);
        }

        if (key == 'category_company') {
          return;
        } else if (key.includes('company.')) {
          const field = key.replace('company.', '');
          const $inputElm = $form.find(fieldSelector(`client_company[company_attributes][${field}]`));
          if (field === 'representative_birthday') {
            if (window.validateRepresentativeBirthday) {
              window.validateRepresentativeBirthday($inputElm);
            }
            hasRenderedInlineError = true;
            return;
          }
          hasRenderedInlineError = addFieldError($inputElm, errors[0]) || hasRenderedInlineError;
        } else {
          const $inputElm = $form.find(fieldSelector(`client_company[${key}]`));
          hasRenderedInlineError = addFieldError($inputElm, errors[0]) || hasRenderedInlineError;
        }
      });

      if (!_.isEmpty(response.nested_errors)) {
        $.each(response.nested_errors, function (modelNested, values) {
          $.each(values, function (key, errors) {
            $.each(errors, function (field, error) {
              if (modelNested == 'project_client_companies') {
                dialogMessages.push(error[0]);
              }
              var $container = $('.card-sub-client')[key];
              var $inputElement = $($container).find(".client_company_company_company_offices_" + field + " input");
              hasRenderedInlineError = addFieldError($inputElement, error[0]) || hasRenderedInlineError;
            });
          });
        });
      }

      if (!hasRenderedInlineError && !dialogMessages.length && response.errors) {
        var firstErrors = Object.values(response.errors)[0];
        if (firstErrors && firstErrors[0]) {
          dialogMessages.push(firstErrors[0]);
        }
      }

      if (dialogMessages.length) {
        showDialogError(_.uniq(dialogMessages));
      }

      focusFirstClientCompanyError();
    }

    $.ajax({
      url: `/client_companies/${id}`,
      method: "PUT",
      dataType: "json",
      data: new FormData($form[0]),
      processData: false,
      contentType: false,
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr('content')
      },
      success: function (response) {
        if (response.status) {
          window.location.href = "/client_companies";
        } else {
          showClientCompanyErrors(response);
        }
      },
      error: function (xhr) {
        if (xhr.responseJSON) {
          showClientCompanyErrors(xhr.responseJSON);
        } else {
          showDialogError('保存に失敗しました。');
        }
      }
    });
  })

  function addErrorTab($elm) {
    var $tabPane = $($elm).closest(".tab-pane");
    var tabId = $tabPane.attr("aria-labelledby");
    if (tabId) {
      $(`#${tabId}`).addClass("has-error");
      return;
    }

    var dataTab = $($elm).closest(".wrap-form-content").data("tab");
    if (dataTab) {
      $(`#${dataTab}, li.${dataTab} > .nav-link`).addClass("has-error");
    }
  }

  function focusFirstClientCompanyError() {
    var $firstError = $("#client-company-edit-form .has-error .help-block:visible").first();
    if (!$firstError.length) return;

    var $input = $firstError.closest(".has-error").find("input, select, textarea").first();
    var element = ($input[0] || $firstError[0]);
    element.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  bindSortElm("#wrap-problem-company");
  bindSortElm("#sale-info-table");

  $(document).on('click', '.js-toggle-problem-responses', function (e) {
    e.preventDefault();
    const $button = $(this);
    const targetId = $button.attr('aria-controls');
    const isExpanded = $button.attr('aria-expanded') === 'true';

    $button.attr('aria-expanded', !isExpanded);
    $(`#${targetId}`).toggleClass('d-none', isExpanded);
  });

  function bindSortElm($wrapElm) {
    $($wrapElm).find(".sort-item").on("click", function () {
      var sortType = $(this).data("sort-type");
      $($wrapElm).find(".sort-item").removeClass("d-none");
      $(this).addClass("d-none");

      var $people = $($wrapElm),
        $peopleli = $people.find('.nested-fields');
      $peopleli.sort(function (a, b) {
        var an = $(a).data("sort-date") || $(a).find(".js-effect-date").val();
        var bn = $(b).data("sort-date") || $(b).find(".js-effect-date").val();

        if (sortType == "up") {
          if (an > bn) {
            return 1;
          }
          if (an < bn) {
            return -1;
          }
        } else {
          if (an > bn) {
            return -1;
          }
          if (an < bn) {
            return 1;
          }
        }

        return 0;
      });

      $peopleli.detach().appendTo($people);
    })
  }
});


function toggleMakerInfo($container) {
  $container.find(".maker-info").toggleClass("d-none");
  $container.find(".maker-container").find('[data-bs-target="#choose_maker"]').toggleClass("d-none");
}

function toggleModelInfo($container, showButton = false) {
  if (showButton) {
    $container.find(".model-info").addClass("d-none");
    $container.find(".model-container").find('[data-bs-target="#choose_model"]').removeClass("d-none");
    return;
  }
  $container.find(".model-info").toggleClass("d-none");
  $container.find(".model-container").find('[data-bs-target="#choose_model"]').toggleClass("d-none");
}


$(document).on('click', '[data-bs-target="#choose_maker"]', function (e) {
  window.makerContainer = $(e.target).closest("tr");
})

function resetModelDialog() {
  $("#choose_model #q_name_cont").val('');
  $('#choose_model [type="submit"]').trigger('click')
}

$(document).on('click', '#choose_maker .js-select-maker', function (e) {
  const makerId = $(this).data("maker-id");
  $(window.makerContainer).find("[data-maker-id]").val(makerId);
  $(window.makerContainer).find(".js-maker-name").html($(this).data("maker-name"));
  toggleMakerInfo($(window.makerContainer));
  $("#choose_model #maker_id").val(makerId);
  toggleModelInfo($(window.makerContainer), true);
  resetModelDialog();
})

$(document).on('change', '.object_lease_type', function () {
  const $importOption = $(this).find('option[data-import-option="true"]');
  if ($importOption.length === 0) return;

  const value = $(this).val();
  const selectedValues = value == null ? [] : (Array.isArray(value) ? value : [value]);
  const importValue = String($importOption.val());
  const hasLinkedValue = selectedValues.some((selectedValue) => selectedValue !== '' && selectedValue !== importValue);
  const shouldSelectImport = !hasLinkedValue;
  if ($importOption.prop('selected') !== shouldSelectImport) {
    $importOption.prop('selected', shouldSelectImport);
    $(this).trigger('change.select2');
  }
})

$(document).on('click', '#choose_model .js-select-model', function (e) {
  const modelId = $(this).data("model-id");
  $(window.makerContainer).find("[data-model-id]").val(modelId);
  $(window.makerContainer).find(".js-model-name").html($(this).data("model-name"));
  $("#choose_model #model_id").val(modelId);
  resetModelDialog();
  toggleModelInfo($(window.makerContainer));
})

$(document).on('show.bs.modal', '#choose_maker', function () {
  let value = $("#choose_maker #q_name_cont").val();
  $("#choose_maker #q_name_cont").val('');
  $('#choose_maker [type="submit"]').trigger('click')
});

$(document).on('show.bs.modal', '#choose_model', function () {
  let value = $("#choose_model #q_name_cont").val();
  if (value.length > 0) {
    $("#choose_model #q_name_cont").val('');
    $('#choose_model [type="submit"]').trigger('click')
  }
});

$(document).on('click', '.close-model-info', function (e) {
  let $target = $(e.target.closest("tr"))
  toggleModelInfo($target);
  $target.find('[data-maker-id]').val('')

})

$(document).on('click', '.close-maker-info', function (e) {
  let $target = $(e.target.closest("tr"))
  toggleMakerInfo($target);
  toggleModelInfo($target, true);
  $target.find('[data-maker-id]').val('')
  $target.find('[data-model-id]').val('')
  $("#choose_maker .row-content").html('')
})

$(document).on('change', '.leasing_company', function () {
  const $select = $(this);
  const $selectedOption = $select.find(':selected');
  const $importOption = $select.find('option[data-import-option="true"]');
  let lease_company_id = $selectedOption.val();

  if ($selectedOption.data('import-option')) return;
  if (lease_company_id) $importOption.remove();

  var element = $(this).closest('tr').find('.object_lease_type')[0];
  $.ajax({
    data: { lease_company_id: lease_company_id },
    method: "get",
    dataType: 'json',
    url: '/client_companies/load_object_lease_types',
    success: function (e) {
      $(element).empty().attr('disabled', false);
      let data = e.map(function (item) {
        return { id: item.id, text: item.name }
      })

      $(element).select2({
        width: '100%',
        theme: 'bootstrap',
        placeholder: '選択してください',
        allowClear: true,
        data: data,
        language: {
          noResults: function () {
            return '見つかりません。';
          },
        },
      });
    }
  })
})
$('span[data-client-company-id]').on('click', function () {
    $('body').loading({
      message: '書類の取得...',
    });
    setTimeout(() => {
      $('body').loading('destroy');
    }, 3000);
});
// onpage loaded
$(document).ready(function () {
  $('.select2-multiple .select2').select2({
    width: '100%',
    theme: 'bootstrap',
    placeholder: '選択してください',
    // allowClear: true,
    language: {
      noResults: function () {
        return '見つかりません。';
      },
    },
  });

  $('.company-code-select').select2({
    width: '100%',
    theme: 'bootstrap',
    placeholder: '顧客表示名',
    allowClear: true,
    language: {
      noResults: function () {
        return 'データなし';
      },
    },
  });

  initClientCompanyAreaTags();
});

function initClientCompanyAreaTags() {
  var $area = $('.js-client-company-area-tags');
  if (!$area.length || !$.fn.select2) return;

  clearTimeout($area.data('areaTagSearchTimer'));
  $area.removeData('areaTagSearchTimer');
  $area.off('select2:select.areaTags select2:unselect.areaTags');
  if ($area.hasClass('select2-hidden-accessible')) $area.select2('destroy');

  $area.select2({
    width: '100%',
    theme: 'bootstrap',
    placeholder: $area.data('placeholder') || '選択してください。',
    tags: true,
    multiple: true,
    tokenSeparators: [','],
    language: {
      noResults: function () {
        return '見つかりません。';
      },
    },
  });

  $area.on('select2:select.areaTags select2:unselect.areaTags', function () {
    var form = this.form;
    if (!form) return;
    var $field = $(this);
    clearTimeout($field.data('areaTagSearchTimer'));
    $field.data('areaTagSearchTimer', setTimeout(function () {
      $field.removeData('areaTagSearchTimer');
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }, 0));
  });
}


$(document).ready(function () {
  $("#add-category-row").on("click", function () {
    let $rowTemplate = $("#categories-table tbody .category-row").last();
    let $newRow = $rowTemplate.clone();
    let $categoryType = $rowTemplate.find(".category-select").val()
    let companyId = $rowTemplate.find(".company-code-select").val();
    let companyName = $rowTemplate.find(".company-code-select option:selected").text().trim();
    let companyCode = $rowTemplate.find(".company-code-select option:selected").data('company-code');

    if (companyId == '') {
      showDialogError("会社名を空白のままにすることはできません");
      return;
    }

    let $targetTable;
    if ($categoryType === "parent_company") {
        $targetTable = $("#parent-client tbody");
        if ($targetTable.find("tr").length > 0) {
          showDialogError('親会社タイプには 1 行のみが許可されます。')
          return;
        }
    } else if($categoryType === "group") {
        $targetTable = $("#group-client tbody");
        if ($targetTable.find("tr input[name='categories[][company_id]'][value='" + companyId + "']").length > 0) {
          showDialogError('グループタイプに重複した会社を追加することはできません')
          return;
        }
    }else if($categoryType === "office") {
      $targetTable = $("#office-client tbody");
      if ($targetTable.find("tr input[name='categories[][company_id]'][value='" + companyId + "']").length > 0) {
        showDialogError('オフィスタイプに重複した会社を追加することはできません')
        return;
      }
    }
    else if($categoryType === "other") {
      $targetTable = $("#other-client tbody");
      if ($targetTable.find("tr input[name='categories[][company_id]'][value='" + companyId + "']").length > 0) {
        showDialogError("重複する企業を「その他」カテゴリに追加することはできません。")
        return;
      }
    }
     else{
      showDialogError("有効なカテゴリタイプを選択してください。");
      return;
    }

    $newRow.find('.category-select').replaceWith(function () {
      return `
              <input type="text" class="form-control company-code-input" value="${companyCode}" disabled>
              <input type="text" name="categories[][category]" class="form-control category hidden" value="${$categoryType}" >
             `;
    });

    $newRow.find(".company-code-select").replaceWith(function () {
      return `
              <input type="text" class="form-control company-code-input" value="${companyName}" disabled>
              <input type="text" name="categories[][company_id]" class="form-control company-code-input hidden" value="${companyId}">
             `;
    });

    $newRow.find(".select2-container").remove();
    $newRow.find(".select2").removeClass("select2-hidden-accessible").removeClass("select2-container--bootstrap");
    $newRow.find(".add-category-row").closest("td").remove();


    let $deleteButton = `<td>
                          <a href="javascript:void(0)" class="btn btn-danger btn-delete-row">
                              <i class="fa fa-trash"></i>
                          </a>
                        </td>`;

    $newRow.append($deleteButton);

    $targetTable.append($newRow);

    $targetTable.on("click", ".btn-delete-row", function () {
      const $row = $(this).closest("tr");

      showDeleteConfirmation({}, function () {
        $row.remove();
      });
    });
  });

  $(document).on('click', '.remove-company-category', function () {
    const id = $(this).data('id');
    const companyOfficeId = $(this).data('office-id');
    const companyOtherId = $(this).data('other-id');
    const category = $(this).data('category');
    const $ele_company = $(this).closest('tr');

    // Sử dụng showDeleteConfirmation
    showDeleteConfirmation({}, function () {
      $.ajax({
        url: `/companies/${id}/remove_row_category`,
        method: 'PATCH',
        dataType: 'json',
        data: {
          category: category,
          company_office_id: companyOfficeId,
          company_other_id: companyOtherId,
        },
        success: function (res) {
          if (res.success === true) {
            showDialogSuccess(res.msg);
            $ele_company.remove();
          } else {
            showDialogError(res.error);
          }
        },
        error: function (err) {
          showDialogError('エラーが発生しました。もう一度試してください');
        },
      });
    });
  });



  $(document).on("change", ".company-code-select", function () {
      const companyID = $(this).val();
      const $row = $(this).closest("tr");

      $.ajax({
        url: `/companies/load_company_information`,
        method: "GET",
        data: { id: companyID },
        success: function (response) {
          if (response.success) {
              let companyInfo = response.data;
              $row.find('.company-name').val(companyInfo.company_name);

              const address1 = companyInfo.address1 || "";
              const address2 = companyInfo.address2 || "";
              let formattedAddress = `${address1} ${address2}`;

              $row.find('.company-address').val(formattedAddress);
              $row.find('.company-phone').val(companyInfo.tel);
          } else {
            showDialogError('会社が見つかりませんでした');
          }
        },
        error: function (xhr) {
            $row.find(".company-info").html(`<p>サーバーエラーが発生しました。</p>`);
        },
      });
  });

});


function calculateAge(birthdayStr) {
  if (!birthdayStr) return '';

  const birthday = new Date(birthdayStr);
  if (Number.isNaN(birthday.getTime())) return '';

  const today = new Date();

  let age = today.getFullYear() - birthday.getFullYear();
  const monthDiff = today.getMonth() - birthday.getMonth();
  const dayDiff = today.getDate() - birthday.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
  }

  return age > 0 ? age : 1;
}

function syncRepresentativeAge(dateValue) {
  const $birthday = $('#client_company_company_attributes_representative_birthday');
  const $age = $('#representative_age');
  if (!$birthday.length || !$age.length) return;

  const value = dateValue !== undefined ? dateValue : $birthday.val();
  if (window.isRepresentativeBirthdayInFuture && window.isRepresentativeBirthdayInFuture(value)) {
    $age.val('');
    return;
  }

  $age.val(calculateAge(value));
}

//Auto generate age from birthday (on load, datepicker apply, and clear)
$(document).ready(function () {
  syncRepresentativeAge();
  $('#client_company_company_attributes_representative_birthday').on('apply.daterangepicker', function (ev, picker) {
    const value = picker && picker.startDate ? picker.startDate.format('YYYY/MM/DD') : $(this).val();
    syncRepresentativeAge(value);
  });
  $('#client_company_company_attributes_representative_birthday').on('change', function () {
    syncRepresentativeAge();
  });
});
